import React from 'react';
import { ProceedButton } from 'components/form-elements/buttons/ProceedButton';
import { ExternalLink } from 'components/links/ExternalLink';
import { ShouldRender } from 'components/ShouldRender';
import { LivingDocuments } from 'components/LivingDocuments';
import { tenantConfig } from 'global/tenant-config';
import { useLivingInfo } from 'services/living-info/living-info';

export const Communication = () => {
  const { livingInfo } = useLivingInfo();

  const communication = React.useMemo(() => (tenantConfig?.areas && tenantConfig.areas[livingInfo.propertyNumber] 
    ? tenantConfig?.areas[livingInfo.propertyNumber]?.communication
    : null),
  [livingInfo]);

  return (
    <>
      <LivingDocuments category="communication" />
    
      <ShouldRender condition={!!communication}>
        <ExternalLink href={communication?.link}>
          <ProceedButton>
            <ProceedButton.Button title={communication?.title} />
            <ProceedButton.Redirect />
          </ProceedButton>
        </ExternalLink>
      </ShouldRender>
    </>
  );
};
